export function canCreateSample(nextProps) {
  return nextProps.isAuthenticated && nextProps.user && !nextProps.user.createdSample;
}
